
import gql from 'graphql-tag';
import { DEFAULT_FULFILLMENT_SETTINGS_FRAGMENT , ESTIMATE_FULFILLMENT_WEIGHT_AND_COST_FRAGMENT} from './fragments.graphql';

export const GET_DEFAULT_FULFILLMENT_SETTINGS = gql`
    query GetDefaultFulfillmentSettings($orderId: ID!) {
        defaultFulfillmentSettings(orderId: $orderId) {
            ...DefaultFulfillmentSettingsResult
        }
    }
    ${DEFAULT_FULFILLMENT_SETTINGS_FRAGMENT}
`;

export const GET_ESTIMATE_FULFILLMENT_WEIGHT_AND_COST = gql`
    query GetEstimateFulfillmentWeightAndCost($orderId: ID!, $parcelProfileId: ID!, $shippingServiceType: String!, $customWeight: Float) {
        estimateFulfillmentWeightAndCost(orderId: $orderId, parcelProfileId: $parcelProfileId, shippingServiceType: $shippingServiceType, customWeight: $customWeight) {
            ...EstimateFulfillmentWeightAndCostResult
        }
    }
    ${ESTIMATE_FULFILLMENT_WEIGHT_AND_COST_FRAGMENT}
`;